import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5d8fad73"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "custom-tabs-label"
};
const _hoisted_2 = {
  class: "tab-pane-img"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "pane-content"
};
const _hoisted_5 = {
  class: "order-info"
};
const _hoisted_6 = {
  class: "inl-block label-color"
};
const _hoisted_7 = {
  class: "label-color1"
};
const _hoisted_8 = {
  class: "inl-block label-color"
};
const _hoisted_9 = {
  class: "mr10 label-color1"
};
const _hoisted_10 = {
  class: "inl-block label-color"
};
const _hoisted_11 = {
  class: "mr10 label-color1"
};
const _hoisted_12 = {
  class: "inl-block label-color"
};
const _hoisted_13 = {
  class: "label-color1"
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  class: "payment-box"
};
const _hoisted_16 = {
  class: "inl-block label-color"
};
const _hoisted_17 = {
  class: "label-color2"
};
const _hoisted_18 = {
  class: "inl-block label-color"
};
const _hoisted_19 = {
  class: "mr10 label-color2"
};
const _hoisted_20 = {
  class: "inl-block label-color"
};
const _hoisted_21 = {
  class: "mr10 label-color2"
};
const _hoisted_22 = {
  class: "inl-block label-color"
};
const _hoisted_23 = {
  class: "label-color2"
};
const _hoisted_24 = {
  class: "inl-block label-color"
};
const _hoisted_25 = {
  class: "label-color2"
};
const _hoisted_26 = {
  class: "label-colortip"
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconjingshi label-colortip-i"
}, null, -1));

const _hoisted_28 = {
  key: 1
};
const _hoisted_29 = {
  class: "payment-box"
};
const _hoisted_30 = {
  class: "payment-box-qrcode"
};
const _hoisted_31 = {
  key: 0,
  class: "tips"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");

  const _component_el_descriptions = _resolveComponent("el-descriptions");

  const _component_QrcodeVue = _resolveComponent("QrcodeVue");

  const _component_el_tab_pane = _resolveComponent("el-tab-pane");

  const _component_el_tabs = _resolveComponent("el-tabs");

  return _openBlock(), _createBlock(_component_el_tabs, {
    modelValue: _ctx.activeKey,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.activeKey = $event),
    class: "tabs",
    onTabClick: _ctx.handleClick
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.paymentList), (name, key) => {
      return _openBlock(), _createElementBlock("div", {
        key: key
      }, [_ctx.activeKey === name ? (_openBlock(), _createBlock(_component_el_tab_pane, {
        key: 0,
        label: key,
        name: name
      }, {
        label: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_createElementVNode("img", {
          src: require(`@/assets/img/imgs/${name}.png`)
        }, null, 8, _hoisted_3)]), _createElementVNode("span", null, _toDisplayString(_ctx.paymentList[name]), 1)])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_descriptions, {
          column: "1"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("Product Name")) + " : ", 1)]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.order.license_type_name) + " * " + _toDisplayString(_ctx.oneYuan === '1' ? '1' : _ctx.order.period) + " " + _toDisplayString(_ctx.$t("month")), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("Quantity")) + " : ", 1)]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.order.quantity), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("Order Number")) + " : ", 1)]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.order.order_no || '-'), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("Order Amount")) + " : ", 1)]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.order.currency === 'RMB' ? '￥' : '$') + _toDisplayString(_ctx.order.order_amount), 1)]),
            _: 1
          })]),
          _: 1
        })]), _ctx.checkPayment() ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_descriptions, {
          column: "1"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("Bank account name")) + " : ", 1)]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.order.info.account_name), 1), _createElementVNode("i", {
              class: "iconfont iconcopy-01 pointer colorMain font13im",
              onClick: _cache[0] || (_cache[0] = $event => _ctx.copyKey(_ctx.order.info.account_name || ''))
            })]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("Bank name")) + " : ", 1)]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.order.info.blank_name), 1), _createElementVNode("i", {
              class: "iconfont iconcopy-01 pointer colorMain font13im",
              onClick: _cache[1] || (_cache[1] = $event => _ctx.copyKey(_ctx.order.info.blank_name || ''))
            })]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("Bank card account number")) + " : ", 1)]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.order.info.blank_number), 1), _createElementVNode("i", {
              class: "iconfont iconcopy-01 pointer colorMain font13im",
              onClick: _cache[2] || (_cache[2] = $event => _ctx.copyKey(_ctx.order.info.blank_number || ''))
            })]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("The remittance amount")) + " : ", 1)]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.order.currency === 'RMB' ? '￥' : '$') + _toDisplayString(_ctx.order.info.amount), 1)]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, null, {
            label: _withCtx(() => [_createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("The order note")) + " : ", 1)]),
            default: _withCtx(() => [_createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.order.info.order_note), 1), _createElementVNode("i", {
              class: "iconfont iconcopy-01 pointer colorMain font13im",
              onClick: _cache[3] || (_cache[3] = $event => _ctx.copyKey(_ctx.order.info.order_note || ''))
            })]),
            _: 1
          }), _createVNode(_component_el_descriptions_item, null, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_26, [_hoisted_27, _createTextVNode(" " + _toDisplayString(_ctx.$t('Please be sure to note the order number when making the payment!')), 1)])]),
            _: 1
          })]),
          _: 1
        }), _createElementVNode("div", {
          class: "copy-btn",
          onClick: _cache[4] || (_cache[4] = $event => _ctx.copyKey(`${_ctx.order.info.account_name || ''}\n${_ctx.order.info.blank_name || ''}\n${_ctx.order.info.blank_number || ''}\n${_ctx.order.info.order_note || ''}`))
        }, _toDisplayString(_ctx.$t('One-click copy')), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_QrcodeVue, {
          value: _ctx.qrCode,
          level: "L",
          size: "150"
        }, null, 8, ["value"])])])]))]), _ctx.activeKey === 'company_pay' ? (_openBlock(), _createElementBlock("p", _hoisted_31, [_createTextVNode(_toDisplayString(_ctx.$t("After the transfer is completed, we confirm that the remittance will be manually reviewed within 24 hours (weekends, statutory holidays may be delayed) If you have any questions, please contact us,")) + _toDisplayString(_ctx.$t('E-mail')) + "：", 1), _createElementVNode("span", {
          onClick: _cache[5] || (_cache[5] = $event => _ctx.copyKey('gobysec@gmail.com'))
        }, "gobysec@gmail.com"), _createTextVNode("," + _toDisplayString(_ctx.$t('Customer service Telegram')) + "：", 1), _createElementVNode("span", {
          onClick: _cache[6] || (_cache[6] = $event => _ctx.copyKey('https://t.me/GobySec'))
        }, "https://t.me/GobySec")])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["label", "name"])) : _createCommentVNode("", true)]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onTabClick"]);
}